import { BagPaymentTermListTableColumn } from '@/bag/bag-payment-term-list/bag-payment-term-list.model';
import { ChangeDetectionStrategy, Component, computed, input, LOCALE_ID } from '@angular/core';

@Component({
	selector: 'app-bag-payment-term-list-table-summary',
	templateUrl: './bag-payment-term-list-table-summary.component.html',
	styleUrls: ['./bag-payment-term-list-table-summary.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [{ provide: LOCALE_ID, useValue: 'pl-PL' }],
})
export class BagPaymentTermListTableSummaryComponent {
	readonly totalAmount = input(0);
	readonly commissionWithInvoice = input(0);
	readonly commissionWithoutInvoice = input(0);
	readonly showCommissionSummary = input(false);

	readonly tableColumns: BagPaymentTermListTableColumn[] = [{ id: 'amount', name: 'Suma kwoty' }];
	readonly tableKeys = this.tableColumns.map((col) => col.id);
	readonly data = computed(() => [{ amount: this.totalAmount() }]);

	readonly commissionColumns: BagPaymentTermListTableColumn[] = [
		{ id: 'withInvoice', name: 'Z fakturą' },
		{ id: 'withoutInvoice', name: 'Brak faktury' },
		{ id: 'total', name: 'Ogółem' },
	];
	readonly commissionKeys = this.commissionColumns.map((col) => col.id);
	readonly commissionData = computed(() => [
		{
			withInvoice: this.commissionWithInvoice(),
			withoutInvoice: this.commissionWithoutInvoice(),
			total: this.commissionWithInvoice() + this.commissionWithoutInvoice(),
		},
	]);
}
